import React, { useState, useRef, useEffect } from "react";

const CustomDropdown = ({ value, onChange }: { value: string; onChange: (value: string) => void }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const options = [
    { value: "active", label: "Active" },
    { value: "pending", label: "Pending" },
    { value: "all", label: "All" },
  ];

  const handleOptionClick = (optionValue: string) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="relative w-[120px]">
      <button
        type="button"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between gap-2 bg-ez-surface text-ez-text-primary rounded-md px-4 py-2.5 cursor-pointer border border-ez-border shadow-sm hover:border-ez-border-strong focus:outline-none focus:ring-2 focus:ring-violet-500/20 transition-colors"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-sm font-medium">
          {options.find((option) => option.value === value)?.label}
        </span>
        <svg
          className={`h-4 w-4 text-ez-text-secondary transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
        </svg>
      </button>
      {isOpen && (
        <ul className="absolute right-0 mt-1 w-full bg-ez-surface text-ez-text-primary rounded-md shadow-card-hover z-20 border border-ez-border overflow-hidden" role="listbox">
          {options.map((option) => (
            <li
              key={option.value}
              className={`px-4 py-2.5 text-sm cursor-pointer transition-colors ${
                option.value === value
                  ? "bg-ez-elevated text-ez-text-primary font-medium"
                  : "hover:bg-ez-elevated text-ez-text-secondary hover:text-ez-text-primary"
              }`}
              onClick={() => handleOptionClick(option.value)}
              role="option"
              aria-selected={option.value === value}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;